export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / k ** i).toFixed(dm)) + ' ' + sizes[i];
};

export const fileSizeInMegaBytes = bytes => {
  return bytes / (1024 * 1024);
};

export const checkFileSizeLimit = (file, maximumUploadLimit) => {
  const fileSize = file?.file?.size || file?.size;
  const fileSizeInMB = fileSizeInMegaBytes(fileSize);
  return fileSizeInMB <= maximumUploadLimit;
};

export const getWhatsAppFileSizeLimit = (file, limits) => {
  const fileType = file?.file?.type || file?.type || '';
  if (fileType === 'image/webp') return limits.sticker;
  if (fileType.startsWith('image/')) return limits.image;
  if (fileType.startsWith('audio/')) return limits.audio;
  if (fileType.startsWith('video/')) return limits.video;
  return limits.document;
};
